import qs from 'qs';

const algoliaUrlToSearchState = ({ search }) => qs.parse(search.slice(1));

export default algoliaUrlToSearchState;
